const relations = {
    en: {
        relations: {
            form: {
                create: {
                    hierarchies: {
                        title: 'Add Hierarchy'
                    },
                    associations: {
                        title: 'Add Association'
                    } 
                }
            },
            associations: {
                children: 'Child Associations',
                category: 'Category',
                tag: 'Tag',
                empty: 'This tag has no child tags.'
            },
            groups: {
                labels: {
                    category: 'Category',
                    tag: 'Tag'
                },
                empty: 'No tags.',
                actions: {
                    add: 'Add',
                    save: 'Save'
                }
            },
            actions: {
                add: 'Add',
                save: 'Save'
            },
            errors: {
                different_tags: "All tags must be different.",
                not_allowed_cardinality: 'Category {0} cardinality does not allow more than 1 association tag. | Categories {0} cardinality do not allow more than 1 association tag.'
            }
        }
    }
}

module.exports.relations = relations; 